<template>
    <div class="tab-menu-wrap">
        <ul class="tab-menu">
            <li class="tab-menu__item"><router-link to="/kr/mypage/health/bloodPressure">혈압</router-link></li>
            <li class="tab-menu__item"><router-link to="/kr/mypage/health/bloodSugar">혈당</router-link></li>
            <li class="tab-menu__item active"><router-link to="/kr/mypage/health/bodyMass">체질량</router-link></li>
        </ul>
    </div>
    <div class="info">
        <div class="table-search">
            <VueDatePicker v-model="selectedDateRange" locale="ko"
                      :enable-time-picker="false" :format="customFormat"
                      :week-start="0" :day-class="getDayClass"
                      :select-text="'선택'" :cancel-text="'취소'" placeholder="날짜를 선택하세요."/>
            

            <TimePicker v-model="time" format="HH:mm" minute-step="1" is24 />
        </div>
        <ul class="blood-scheduler">
            <li class="blood-scheduler__item">
                <div class="blood-scheduler__con">
                    <div class="blood-scheduler__top">
                        <div class="blood-scheduler--img">
                            <img v-if="$store.state.hospStore.hostNm == '대동맥혈관병원'" src="/resource/icon/mypage-main__item6-icon07.svg" class="" alt="">
                            <img v-else-if="$store.state.hospStore.hostNm == '뇌혈관병원'" src="/resource/icon/mypage-main__item6-icon07-brain.svg" class="" alt="">
                            <img v-else-if="$store.state.hospStore.hostNm == '엄마아기병원'" src="/resource/icon/mypage-main__item6-icon07-mom.svg" class="" alt="">
                        </div>
                        <h3 class="title02">성별</h3>
                    </div>
                    <div class="blood-scheduler__input radio-wrap">
                        <label  >
                            <input type="radio" name="test01" id="test01" value="M" v-model="gender">
                            <span  class="radio-btn"></span>
                            <p>남자</p>
                        </label>
                        <label  >
                            <input type="radio" name="test02" id="test02" value="F" v-model="gender">
                            <span  class="radio-btn"></span>
                            <p>여자</p>
                        </label>
                    </div>
                </div>
            </li>
            <li class="blood-scheduler__item">
                <div class="blood-scheduler__con">
                    <div class="blood-scheduler__top">
                        <div class="blood-scheduler--img">
                            <img v-if="$store.state.hospStore.hostNm == '대동맥혈관병원'" src="/resource/icon/mypage-main__item6-icon06.svg" class="" alt="">
                            <img v-else-if="$store.state.hospStore.hostNm == '뇌혈관병원'" src="/resource/icon/mypage-main__item6-icon06-brain.svg" class="" alt="">
                            <img v-else-if="$store.state.hospStore.hostNm == '엄마아기병원'" src="/resource/icon/mypage-main__item6-icon06-mom.svg" class="" alt="">
                        </div>
                        <h3 class="title02">키</h3>
                    </div>
                    <div class="blood-scheduler__input">
                        <input type="text" v-model="height" @input="validateHeight">
                        <p class="title03">cm</p>
                    </div>
                </div>
            </li>
            <li class="blood-scheduler__item">
                <div class="blood-scheduler__con">
                    <div class="blood-scheduler__top">
                        <div class="blood-scheduler--img">
                            <img v-if="$store.state.hospStore.hostNm == '대동맥혈관병원'" src="/resource/icon/mypage-main__item6-icon03.svg" class="" alt="">
                            <img v-else-if="$store.state.hospStore.hostNm == '뇌혈관병원'" src="/resource/icon/mypage-main__item6-icon03-brain.svg" class="" alt="">
                            <img v-else-if="$store.state.hospStore.hostNm == '엄마아기병원'" src="/resource/icon/mypage-main__item6-icon03-mom.svg" class="" alt="">
                        </div>
                        <h3 class="title02">몸무게</h3>
                    </div>
                    <div class="blood-scheduler__input">
                        <input type="text" v-model="weight" @input="validateWeight">
                        <p class="title03">kg</p>
                    </div>
                </div>
            </li>
        </ul>
        <div class="botton-wrap">
            <a href="javascript:;" class="main-button c-main" @click="calculateBMI">측정하기</a>
        </div>
    </div>
    <div class="info" v-if="!result">
        <div class="text-box type3">
            <h3 class="title03">체질량 측정 방법</h3>
            <p class="bullet03">신체질량지수(BMI) = <span v-html="renderFraction"></span></p>
            <p class="bullet03">
                <span><span class="font-blue">판정기준 </span> <br>
                저체중: 18.5 미만  정상 : 18.5 ~ 23  과체중 : 23 ~ 25 비만 : 25 ~ 30 고도비만 : 30 이상</span>
            </p>
            
        </div>
    </div>

    <!-- 측정시 -->
    <div class="info" v-if="result">
        <div class="text-box type3">
            <div class="emphasis">
                <div class="emphasis--icon">
                    <span style="display: contents;" v-if="result == '정상'">
                        <img v-if="$store.state.hospStore.hostNm == '대동맥혈관병원'" src="/resource/icon/emphasis-good.svg" class="" alt="">
                        <img v-else-if="$store.state.hospStore.hostNm == '뇌혈관병원'" src="/resource/icon/emphasis-good-brain.svg" class="" alt="">
                        <img v-else-if="$store.state.hospStore.hostNm == '엄마아기병원'" src="/resource/icon/emphasis-good-mom.svg" class="" alt="">
                    </span>
                    <span style="display: contents;" v-else>
                        <img v-if="$store.state.hospStore.hostNm == '대동맥혈관병원'" src="/resource/icon/emphasis-warning.svg" class="" alt="">
                        <img v-else-if="$store.state.hospStore.hostNm == '뇌혈관병원'" src="/resource/icon/emphasis-warning-brain.svg" class="" alt="">
                        <img v-else-if="$store.state.hospStore.hostNm == '엄마아기병원'" src="/resource/icon/emphasis-warning-mom.svg" class="" alt="">
                    </span>
                </div>
                <h3 class="title01">현재 신체정보는 {{staticHeight}} cm / {{staticWeight}} kg 으로<br>
                    BMI 지수는 {{staticBmi.toFixed(2)}}kg/m² <br class="show-mo"><span :class="result == '정상' ? 'c-blue' : 'c-red'">‘{{result}}’</span> 입니다.
                </h3>
            </div>
        </div>
    </div>
    <div class="info" v-if="result">
        <div class="table-wrap">
            <div class="table">
                <div class="table__inner">
                    <table>
                        <colgroup>
                            <col style="width:50%;">
                            <col style="width:50%;">
                        </colgroup>
                        <thead>
                            <tr>
                                <th>판정분류</th>
                                <th>BMI 지수</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>저체중</td>
                                <td>18.5 미만</td>
                            </tr>
                            <tr>
                                <td>정상</td>
                                <td>18.5~23</td>
                            </tr>
                            <tr>
                                <td>과체중</td>
                                <td>23~25</td>
                            </tr>
                            <tr>
                                <td>비만</td>
                                <td>25~30</td>
                            </tr>
                            <tr>
                                <td>고도비만</td>
                                <td>30이상</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="botton-wrap" v-if="result">
            <a href="javascript:;" class="main-button c-main" @click="saveSubmit">결과저장</a>
        </div>
    </div>
    <kr_popup_health ref="MypagePopupVue"/>
</template>

<script>
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import TimePicker from 'vue3-timepicker';
import 'vue3-timepicker/dist/VueTimepicker.css';
import katex from 'katex';
import 'katex/dist/katex.min.css';
import { useRoute } from 'vue-router'

export default {
    components: {
        VueDatePicker,
        TimePicker,
    },
    data() {
        return {
            time: {HH:"", mm:""},  // 시간 선택값을 저장
            selectedDateRange: new Date, // 날짜 선택값
            customFormat: 'yyyy-MM-dd',  // 날짜 포맷
            fraction: '\\frac{체중(kg)}{[신장(m)]²}',  // LaTeX 수식

            gender: '',
            height: '',
            weight: '',
            result: '',
            bmi: 0,
            staticHeight: '',
            staticWeight: '',
            staticBmi: '',
        };
    },
    computed: {
        renderFraction() {
            return katex.renderToString(this.fraction);  // KaTeX로 수식 렌더링
        }
    },
    methods: {
        validateHeight(event) {
            const input = event.target.value.replace(/[^\d]/g, '').slice(0, 3)
            this.height = input
        },
        validateWeight(event) {
            const input = event.target.value.replace(/[^\d]/g, '').slice(0, 3)
            this.weight = input
        },
        calculateBMI() {
            if (!this.height || !this.weight) {
                alert("수치를 입력해 주세요")
                return
            }

            this.staticHeight = this.height
            this.staticWeight = this.weight

            const heightInMeters = this.height / 100
            this.bmi = this.weight / (heightInMeters * heightInMeters)
            this.staticBmi = this.bmi

            if (this.bmi < 18.5) {
                this.result = '저체중'
            } else if (this.bmi >= 18.5 && this.bmi < 23) {
                this.result = '정상'
            } else if (this.bmi >= 23 && this.bmi < 25) {
                this.result = '과체중'
            } else if (this.bmi >= 25 && this.bmi < 30) {
                this.result = '비만'
            } else if (this.bmi >= 30) {
                this.result = '고도비만'
            }

            if(this.result){
                this.$nextTick(() => {
                    const el = document.querySelector('.text-box.type3')
                    const top = el.getBoundingClientRect().top;
                    const curY = window.pageYOffset
                    const header = document.querySelector('.header-bottom').clientHeight
                    const sum = top + curY - header
                    window.scrollTo({top: sum})
                });
            }
        },
        saveSubmit() {
            this.$refs.MypagePopupVue.popupBtn()
        },
        submit() {
            let reqData = {
                hmCd: 'BM'
            }

            var year = this.selectedDateRange.getFullYear()
            var month = ('0' + (this.selectedDateRange.getMonth() + 1)).slice(-2)
            var day = ('0' + this.selectedDateRange.getDate()).slice(-2)
            var hours = this.time.HH ? this.time.HH : ('0' + this.time.getHours()).slice(-2)
            var min = this.time.mm ? this.time.mm : ('0' + this.time.getMinutes()).slice(-2)

            reqData.logDt = year + '' + month + '' + day + '' + hours + '' + min + '00'
            reqData.gender = this.gender
            reqData.record1 = this.staticHeight
            reqData.record2 = this.staticWeight
            reqData.record3 = this.staticBmi
            reqData.result = this.result
            this.axios({
                method: "post",
                url: this.api.mypage.healthReg,
                params: reqData
            }).then(response => {
                alert('저장되었습니다.')
                this.height = ''
                this.weight = ''
                this.bmi = ''
                this.result = ''
                this.staticHeight = ''
                this.staticWeight = ''
                this.staticBmi = ''

                this.$router.push('/kr/mypage/health/bloodMain')
            })
        },
    },
    mounted() {
        this.gender = this.$store.state.myInfoStore.gender ? this.$store.state.myInfoStore.gender : 'M'

        const now = new Date();

        this.time.HH = now.getHours().toString().padStart(2, '0');
        this.time.mm = now.getMinutes().toString().padStart(2, '0');

        this.selectedDateRange = this.$store.state.reserveStore.bloodDate || now

        // 테이블의 .table에 클릭 이벤트를 추가
        const tables = document.querySelectorAll('.table');

        tables.forEach((table) => {
            // .table 요소의 가상 요소 부분을 클릭한 것처럼 처리할 수 있게,
            // 테이블의 `::before`가 클릭될 수 있는 영역을 감싸는 영역을 클릭 이벤트로 처리
            table.addEventListener('click', () => {
                // 테이블에 'active' 클래스를 토글
                table.classList.add('active');
            });
        });
    },
    beforeUnmount() {
        if(!(useRoute().path == '/kr/mypage/health/bloodPressure'
            || useRoute().path == '/kr/mypage/health/bloodSugar'
            || useRoute().path == '/kr/mypage/health/bodyMass')) this.$store.commit('setBloodDate', '')
    },
}
</script>

<style scoped></style>